import React from 'react'
import { Navigate } from 'react-router'
import { useTranslation } from '../../hooks'

function TaskNotFound() {
  const { i18n } = useTranslation();

  return (
    <Navigate
      to="/message"
      replace
      state={{ title: i18n('cp_something_went_wrong'), copy: i18n('cp_something_unexpected_happened') }}
    />
  )
}

export default TaskNotFound
